<template>
     <div class="box">
        <div class="form">
            <van-field class="title" label="申诉情况" readonly />
            <!-- <van-field
                readonly
                autosize
                label="申诉内容"
                type="textarea"
                show-word-limit
                :value="appealDetail.appealContent"
            /> -->
            <div class="field">
                <div class="label">申诉内容</div>
                <div class="content">{{ appealDetail.appealContent }}</div>
            </div>
            <van-field class="border-bottom-0" label="相关凭证" readonly />
            <div v-if="appealDetail.appealAttachList && appealDetail.appealAttachList.length > 0" class="imglist">
                <img :src="i" v-for="(i, index) in appealDetail.appealAttachList" @click="preview(appealDetail.appealAttachList, index)" :key="index" alt="">
            </div>
            <van-field label="申诉时间" :value="appealDetail.time" readonly />
            </div>
        <div class="form">
            <van-field v-if="appealDetail.feedbackUserName" class="title" label="申诉反馈情况" readonly />
            <van-field
                readonly
                v-if="appealDetail.feedbackContent"
                rows="2"
                autosize
                label="反馈内容"
                type="textarea"
                show-word-limit
                :value="appealDetail.feedbackContent"
            />
            <van-field v-if="appealDetail.feedbackAttachList" class="border-bottom-0" label="相关凭证" readonly />
            <div v-if="appealDetail.feedbackAttachList" class="imglist">
                <img :src="i" v-for="(i, index) in appealDetail.feedbackAttachList" @click="preview(appealDetail.feedbackAttachList, index)" :key="index" alt="">
            </div>
            <van-field v-if="appealDetail.feedbackOrgName" label="处置机构" :value="appealDetail.feedbackOrgName" readonly />
            <van-field
                readonly
                v-if="appealDetail.feedbackUserName"
                center
                clearable
                label="处置人员"
                :value="appealDetail.feedbackUserName"
            >
                <template #button>
                <a class="call-icon" @click="util.callConfirm('拨打该号码？', appealDetail.feedbackUserTel, 6)" href="javascript:void(0)" />
                </template>
            </van-field>
            <van-field v-if="appealDetail.feedbackTimeFormat" label="处置时间" :value="appealDetail.feedbackTimeFormat" readonly />
            <van-field v-if="auditDetail.auditStatus" label="审核结果" :value="auditDetail.auditStatus" readonly />

            <van-field
                readonly
                v-if="auditDetail && auditDetail.auditContent"
                rows="2"
                autosize
                label="补充说明"
                type="textarea"
                show-word-limit
                :value="auditDetail.auditContent"
            />

            <van-field v-if="auditDetail && auditDetail.auditOrgName" label="审核机构" :value="auditDetail.auditOrgName" readonly />
            <van-field
                readonly
                v-if="auditDetail && auditDetail.auditUserName"
                center
                clearable
                label="审核人员"
                :value="auditDetail.auditUserName"
            >
            <template #button>
                <a class="call-icon" @click="util.callConfirm('拨打该号码？', auditDetail.auditUserTel, 6)" href="javascript:void(0)" />
            </template>
            </van-field>
            <van-field v-if="auditDetail.auditTimeFormat" label="审核时间" :value="auditDetail.auditTimeFormat" readonly />

        </div>
        </div>
</template>

<script>
    import util from '../../../../utils/common'
    import api from '../../../../service/modules/refund'
    import { ImagePreview } from 'vant'

    export default {
        data () {
            return {
                detail: {},
                appealDetail: {
                    appealAttachList: [],
                    appealContent: '',
                    time: '',
                    feedbackContent: '',
                    feedbackOrgName: '',
                    disposalStaff: '',
                    feedbackTimeFormat: '',
                    auditStatusStr: '',
                    auditContent: '',
                    auditOrgName: '',
                    phone: '',
                    auditTimeFormat: '',
                    memoJson: {}

                }, // 申诉的审核有关信息
                auditDetail: {} // 审核详情
                // appealListIndex: 0,

            }
        },
        created () {
            // this.appealListIndex = this.$route.query.appealListIndex
            
            this.detail = this.$store.state.refund.detail
            this.setDetail()
        },
        methods: {
            preview (imglist, index) {
                  window.history.pushState(null, null, "#");
                const that = this
                ImagePreview({
                    images: imglist,
                    startPosition: index,
                      onClose() {
                      console.log('window.location.href', window.location.href);
                      if (window.location.href.indexOf('appealDetails') === -1) {
                        that.$router.back()
                      }
                    }
                })
            },
            setDetail () {
                // if (this.detail && this.detail.history) {
                //     this.disposalDetails = this.detail.history.find(i => i.optText === '申诉已反馈' || i.optText === '游客反馈')
                //     this.disposalDetails.time = util.getStampInDate(this.disposalDetails.creatTime, '/')
                // }
                if (this.detail && this.detail.appealList && this.detail.appealList.length > 0) {
                    console.log('item', this.$route.query.item)

                    this.appealDetail = this.$route.query.item.appealDeatil // 审核详情

                    // 审核详情
                    if (this.$route.query.item.memoJson) {
                        console.log('JSON.parse(this.$route.query.item.memoJson)', JSON.parse(this.$route.query.item.memoJson))
                        this.auditDetail = JSON.parse(this.$route.query.item.memoJson)
                        if (this.auditDetail.auditTime) {
                            this.auditDetail.auditTimeFormat = util.getStampInDate(this.auditDetail.auditTime, '/')
                        } else {
                            this.auditDetail.auditTimeFormat = ''
                        }
                    }

                    if (this.appealDetail.appealTime) {
                        this.appealDetail.time = util.getStampInDate(this.appealDetail.appealTime, '/')
                    }

                    if (this.appealDetail.feedbackTime) {
                        this.appealDetail.feedbackTimeFormat = util.getStampInDate(this.appealDetail.feedbackTime, '/')
                    }
                    if (this.appealDetail.auditTime) {
                        this.appealDetail.auditTimeFormat = util.getStampInDate(this.appealDetail.auditTime, '/')
                    }

                    if (this.appealDetail.feedbackAttachList) {
                        this.appealDetail.feedbackAttachList = this.appealDetail.feedbackAttachList.split(',')
                    }
                    console.log('this.appealDetail', this.appealDetail)

                    // const auditStatusOption = {
                    //     'TO_AUDIT': '待审核',
                    //     'EMP_INCOMPLETE': '通过',
                    //     'USER_INCOMPLETE': '不通过'
                    // }

                    // this.appealDetail.auditStatusStr = auditStatusOption[this.appealDetail.auditStatus]

                    // this.appealDetail.phone = this.getPhone(this.appealDetail.auditUserId)

                    // this.appealDetail.disposalStaffPhone = this.getPhone(this.appealDetail.userid)
                }
            },
            getPhone (id) {
                let phone
                const param = {
                    // userId: '6a443f811a18aa74642830a4647edf54'
                    userId: id
                }
                api.getUserByUserId(param).then(r => {
                    if (r.ret === 0) {
                        phone = r.data.mobile
                    }
                })
                return phone
            }

        }
    }
</script>

<style lang="less" scoped>
     .box {
        padding: 16px 16px 0;
        background-color: #f8f9fc;
        min-height: 100vh;
        padding-bottom: 30px;
        /deep/.form {
            margin-bottom: 16px;
            border-radius: 4px;
            background-color: white;

            .field {
                display: flex;
                padding: 10px 16px;
                .label {
                    font-size: 14px;
                    color: #646566;
                    margin-right: 16px;
                    flex: none;
                    line-height: 20px;
                }
                .content {
                    font-size: 14px;
                    color: #323233;
                    line-height: 20px;
                }
            }


            .van-field__label {
                min-width: 56px;
                // width: 56px;
                margin-right: 16px;
            }
            .title {
                span {
                    font-weight: 600;
                }
            }
            .border-bottom-0::after {
                border-bottom: 0;
            }
            .signImg {
                border-radius: 4px;
                background-color: white;
                padding: 0 16px 16px;
                width: 100%;
                height: 280px;
                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 4px;
                    padding-bottom: 16px;
                    border-bottom: 1px solid #f9f9f9;
                }
            }
            .imglist {
                display: flex;
                background-color: white;
                padding: 0 16px 0;
                flex-wrap: wrap;

                img {
                    width: 80px;
                    height: 80px;
                    margin-right: 15px;
                    border-radius: 4px;
                    margin-bottom: 15px;
                }
            }
            .call-icon {
                display: inline-block;
                width: 24px;
                height: 24px;
                background-repeat: no-repeat;
                background-size: 100% 100%;
                background-image: url('../../../../assets/refund/icon_ts_dh@2x.png');
            }
        }
    }
</style>
